import { requestAnimationFrame } from 'utilities/dom';

// double-wrapped defer is the only foolproof way to make sure this
// action happens AFTER an element is actually rendered to the DOM.
// E.g. within componentDidMount, the element of the component has
// been registered by the browser, but a reflow hasn't happened yet
// so it's not actually IN the DOM until after that happens
export const defer = cb => {
  requestAnimationFrame(() => {
    window.setTimeout(() => {
      cb();
    }, 0);
  });
};
